import { memo } from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';

import { I13nAnchor } from 'Components/I13n';

type Props = {
  className?: string;
  rootClassName?: string;
  itemClassName?: string;
  itemColorClassName?: string;
  hide?: boolean;
  menuItems?: any[];
  depth?: number;
  tabIndex?: number;
};

const HeaderMenuItem = (props: Props) => {
  const {
    className,
    rootClassName,
    itemClassName,
    itemColorClassName,
    hide,
    menuItems,
    depth = 0,
    tabIndex = 0,
  } = props;

  const { formatMessage } = useIntl();

  const ulClassName = rootClassName
    ? {
        'D(n)': hide,
        [rootClassName]: !depth,
      }
    : {
        'D(n)': hide,
      };

  if (!menuItems) {
    return null;
  }

  return (
    <ul className={classNames(className, ulClassName)} role="menu" tabIndex={tabIndex}>
      {menuItems.map((item, index) => {
        const Tag = item.href ? I13nAnchor : 'span';
        return (
          <li key={index} className={classNames('List(n)', itemClassName)} role="none">
            <Tag
              href={item.href}
              className={classNames(itemColorClassName, {
                'Fw($bold)': !depth,
                'Fw($semibold)': depth,
              })}
              role="menuitem"
            >
              {formatMessage({ id: item.id })}
            </Tag>
            {item.items && <HeaderMenuItem {...props} menuItems={item.items} depth={depth + 1} />}
          </li>
        );
      })}
    </ul>
  );
};

export default memo(HeaderMenuItem);
